import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import axios from "axios";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export default function EmployeeSalarySearchTable(props) {
    const { data,onRowClicks,AutoOptions,months} = props;

    const stylH = {
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "#000",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }

    const { t } = useTranslation(["forms", "translation"]);
    const classes = useStyles();

      function GetEmpFromOptions(id, options) {
        const index = options?.findIndex((op) => op.id == id);
        return options[index];
      }
    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor:"#4a82b9",
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {t("voucher-no")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("date")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("employee")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("amount")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("month")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("year")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("responsible-employee")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("statement")}
                        </TableCell>
                        
                      
                               
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.id}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                border: "solid 0.6px"
                            }}
                           >

                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} >{row?.id}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} >{row?.date}</TableCell>

                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} > {row?.emp_name}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} > {row?.salary_net}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} > { 
                             GetEmpFromOptions( row?.month, months).name
                              }</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} > {row?.year}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} > { 
                            GetEmpFromOptions(row?.emp_resp, AutoOptions?.Employees).name 
                            }</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClicks(row); }} > {row?.notes}</TableCell>



                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
